import styled from 'styled-components';

export const SeachBarWrapper = styled.div`
  margin-top: 5.9rem;
`;
